<!--提交成功-->
<template>
  <div class="SubmitSuccess" style="height: 100vh; background: #ffcd45">
    <img src="../assets/submitFinish.jpeg" style="width: 100%" />
  </div>
</template>